<template>
	<div class="container remove-padding-margin">
		
		<main class="add-padding-default">
			<div id="loadingPage" v-if="verifikasiState === 'loading'">
				<span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
			</div>
			
			<div class="flex-100" v-if="verifikasiState === 'success'">
				<div class="flex-1">
					<div class="text-alignC mar-top-144"><img src="../../assets/icons/mdi_email-check-outline.svg" alt=""></div>
					<div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">
						Berhasil mengubah email
					</div>
					<div class="color-8080 text-center letter-space-002 line-height-21 font-14">
						Anda sekarang bisa melakukan login menggunakan email yang baru.
					</div>
				</div>
				<div>
					<div class="button-lanjut">
						<button class="btn btn-login btn-long" id="btnsuccess" @click="godetailakun">
							<span id="textbtnsuccess">Kembali ke Depan</span>
						</button>
					</div>
				</div>
			</div>
			
			<div class="flex-100" v-if="verifikasiState === 'failed'">
				<div class="flex-1">
					<div class="text-alignC mar-top-144"><img src="../../assets/icons/ic_baseline-email.svg" alt=""></div>
					<div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">
						Gagal mengubah email
					</div>
					<div class="color-8080 text-center letter-space-002 line-height-21 font-14">
						Mohon ulangi proses verifikasi email.
						<br>
						(error: {{errorMsg}})
					</div>
				</div>
				<div>
					<div class="button-lanjut">
						<button class="btn btn-login btn-long" id="btnfailed" @click="godetailakun">
							<span id="textbtnfailed">Ulangi Proses Verifikasi Email</span>
						</button>
					</div>
				</div>
			</div>
			
			<div class="flex-100" v-if="verifikasiState === 'expired'">
				<div class="flex-1">
					<div class="text-alignC mar-top-144"><img src="../../assets/icons/ic_baseline-email.svg" alt=""></div>
					<div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">
						Link Verifikasi Email Telah Kadaluarsa
					</div>
					<div class="color-8080 text-center letter-space-002 line-height-21 font-14">
						Mohon ulangi proses verifikasi email.
					</div>
				</div>
				<div>
					<div class="button-lanjut">
						<button class="btn btn-login btn-long" id="btnexpired" @click="godetailakun">
							<span id="textbtnexpired">Ulangi Proses Verifikasi Email</span>
						</button>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	export default {
		name: "VerifikasiEmail",
		data(){
			return{
				verifikasiState: "loading",
				requestHeaders: {
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token'),
					}
				},
				errorMsg: ""
			}
		},
		mounted(){
			this.verifikasi()
		},
		methods:{
			godashboard(){
				this.$router.push('/dashboard')
			},
			godetailakun(){
				// this.$router.push('/loginowneremail')
				this.$router.push('/')
			},
			
			async verifikasi() {
				try {
					var code = this.$route.params.code
					var formData = new FormData()
					formData.append("code_encryption", code)
					const res = await this.$axios.post(this.$baseurl + '/auth/verifikasi_atur_email_baru', formData, this.requestHeaders)
					// console.log("res", res)
					if (res.data.status) {
						this.verifikasiState = "success"
					} else {
						if (res.data.code === 200) {
							this.verifikasiState = "expired"
						} else {
							this.verifikasiState = "failed"
							this.$toast.error(res)
							this.errorMsg = res.data.msg
						}
					}
				} catch (e) {
					this.verifikasiState = "failed"
					this.$toast.error(res)
					this.errorMsg = res.data.msg
				}
			},
		}
	}
</script>

<style scoped>

</style>